export default "__VITE_ASSET__c5907b7d__"